import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FontService {

  public fontFamilyOptions = [
    {
      "name": "Exo",
      "url": "../assets/fonts/exo/Exo-Regular-msdf.json",
      "class": "font-exo"
    },
    {
      "name": "Exo Bold",
      "url": "../assets/fonts/exo/Exo-Bold-msdf.json",
      "class": "font-exo-bold"
    },
    {
      "name": "Exo2",
      "url": "../assets/fonts/exo2/Exo2-Regular-msdf.json",
      "class": "font-exo-2"
    },
    {
      "name": "Exo2 Bold",
      "url": "../assets/fonts/exo2/Exo2-Bold-msdf.json",
      "class": "font-exo-2-bold"
    },
    {
      "name": "Fenix",
      "url": "../assets/fonts/fenix/Fenix-Regular-msdf.json",
      "class": "font-fenix"
    },
    {
      "name": "Josefin Sans",
      "url": "../assets/fonts/josefinsans/JosefinSans-Regular-msdf.json",
      "class": "font-josefin-sans"
    },
    {
      "name": "Josefin Sans Bold",
      "url": "../assets/fonts/josefinsans/JosefinSans-Bold-msdf.json",
      "class": "font-josefin-sans-bold"
    },
    {
      "name": "Josefin Slab",
      "url": "../assets/fonts/josefinslab/JosefinSlab-Regular-msdf.json",
      "class": "font-josefin-slab"
    },
    {
      "name": "Josefin Slab Bold",
      "url": "../assets/fonts/josefinslab/JosefinSlab-Bold-msdf.json",
      "class": "font-josefin-slab-bold"
    },
    {
      "name": "Karla",
      "url": "../assets/fonts/karla/Karla-Regular-msdf.json",
      "class": "font-karla"
    },
    {
      "name": "Karla Bold",
      "url": "../assets/fonts/karla/Karla-Bold-msdf.json",
      "class": "font-karla-bold"
    },
    {
      "name": "Lato",
      "url": "../assets/fonts/lato/Lato-Regular-msdf.json",
      "class": "font-lato"
    },
    {
      "name": "Lato Bold",
      "url": "../assets/fonts/lato/Lato-Bold-msdf.json",
      "class": "font-lato-bold"
    },
    {
      "name": "Libre Baskerville",
      "url": "../assets/fonts/librebaskerville/LibreBaskerville-Regular-msdf.json",
      "class": "font-libre-baskerville"
    },
    {
      "name": "Libre Baskerville Bold",
      "url": "../assets/fonts/librebaskerville/LibreBaskerville-Bold-msdf.json",
      "class": "font-libre-baskerville-bold"
    },
    {
      "name": "Montserrat",
      "url": "../assets/fonts/montserrat/Montserrat-Regular-msdf.json",
      "class": "font-montserrat"
    },
    {
      "name": "Montserrat Bold",
      "url": "../assets/fonts/montserrat/Montserrat-Bold-msdf.json",
      "class": "font-montserrat-bold"
    },
    {
      "name": "Muli",
      "url": "../assets/fonts/muli/Muli-Regular-msdf.json",
      "class": "font-muli"
    },
    {
      "name": "Muli Bold",
      "url": "../assets/fonts/muli/Muli-Bold-msdf.json",
      "class": "font-muli-bold"
    },
    {
      "name": "Nunito",
      "url": "../assets/fonts/nunito/Nunito-Regular-msdf.json",
      "class": "font-nunito"
    },
    {
      "name": "Nunito Bold",
      "url": "../assets/fonts/nunito/Nunito-Bold-msdf.json",
      "class": "font-nunito-bold"
    },
    {
      "name": "Open Sans",
      "url": "../assets/fonts/opensans/OpenSans-Regular-msdf.json",
      "class": "font-open-sans"
    },
    {
      "name": "Open Sans Bold",
      "url": "../assets/fonts/opensans/OpenSans-Bold-msdf.json",
      "class": "font-open-sans-bold"
    },
    {
      "name": "PT Sans",
      "url": "../assets/fonts/ptsans/PTSans-Regular-msdf.json",
      "class": "font-pt-sans"
    },
    {
      "name": "PT Sans Bold",
      "url": "../assets/fonts/ptsans/PTSans-Bold-msdf.json",
      "class": "font-pt-sans-bold"
    },
    {
      "name": "PT Sans Caption",
      "url": "../assets/fonts/ptsanscaption/PTSansCaption-Regular-msdf.json",
      "class": "font-pt-sans-caption"
    },
    {
      "name": "PT Sans Caption Bold",
      "url": "../assets/fonts/ptsanscaption/PTSansCaption-Bold-msdf.json",
      "class": "font-pt-sans-caption-bold"
    },
    {
      "name": "PT Sans Narrow",
      "url": "../assets/fonts/ptsansnarrow/PTSansNarrow-Regular-msdf.json",
      "class": "font-pt-sans-narrow"
    },
    {
      "name": "PT Sans Narrow Bold",
      "url": "../assets/fonts/ptsansnarrow/PTSansNarrow-Bold-msdf.json",
      "class": "font-pt-sans-narrow-bold"
    },
    {
      "name": "PT Serif",
      "url": "../assets/fonts/ptserif/PTSerif-Regular-msdf.json",
      "class": "font-pt-serif"
    },
    {
      "name": "PT Serif Bold",
      "url": "../assets/fonts/ptserif/PTSerif-Bold-msdf.json",
      "class": "font-pt-serif-bold"
    },
    {
      "name": "Quattrocento Sans",
      "url": "../assets/fonts/quattrocentosans/QuattrocentoSans-Regular-msdf.json",
      "class": "font-quattrocento-sans"
    },
    {
      "name": "Quattrocento Sans Bold",
      "url": "../assets/fonts/quattrocentosans/QuattrocentoSans-Bold-msdf.json",
      "class": "font-quattrocento-sans-bold"
    },
    {
      "name": "Quicksand",
      "url": "../assets/fonts/quicksand/Quicksand-Regular-msdf.json",
      "class": "font-quicksand"
    },
    {
      "name": "Quicksand Bold",
      "url": "../assets/fonts/quicksand/Quicksand-Bold-msdf.json",
      "class": "font-quicksand-bold"
    },
    {
      "name": "Raleway",
      "url": "../assets/fonts/raleway/Raleway-Regular-msdf.json",
      "class": "font-raleway"
    },
    {
      "name": "Raleway Bold",
      "url": "../assets/fonts/raleway/Raleway-Bold-msdf.json",
      "class": "font-raleway-bold"
    },
    {
      "name": "Roboto",
      "url": "../assets/fonts/roboto/Roboto-Regular-msdf.json",
      "class": "font-roboto"
    },
    {
      "name": "Roboto Bold",
      "url": "../assets/fonts/roboto/Roboto-Bold-msdf.json",
      "class": "font-roboto-bold"
    },
    {
      "name": "Sanchez",
      "url": "../assets/fonts/sanchez/Sanchez-Regular-msdf.json",
      "class": "font-sanchez"
    },
    {
      "name": "Sofia",
      "url": "../assets/fonts/sofia/Sofia-Regular-msdf.json",
      "class": "font-sofia"
    },
    {
      "name": "Source Code Pro",
      "url": "../assets/fonts/sourcecodepro/SourceCodePro-Regular-msdf.json",
      "class": "font-source-code-pro"
    },
    {
      "name": "Source Code Pro Bold",
      "url": "../assets/fonts/sourcecodepro/SourceCodePro-Bold-msdf.json",
      "class": "font-source-code-pro-bold"
    },
    {
      "name": "Source Sans Pro",
      "url": "../assets/fonts/sourcesanspro/SourceSansPro-Regular-msdf.json",
      "class": "font-source-sans-pro"
    },
    {
      "name": "Source Sans Pro Bold",
      "url": "../assets/fonts/sourcesanspro/SourceSansPro-Bold-msdf.json",
      "class": "font-source-sans-pro-bold"
    },
    {
      "name": "Source Serif Pro",
      "url": "../assets/fonts/sourceserifpro/SourceSerifPro-Regular-msdf.json",
      "class": "font-source-serif-pro"
    },
    {
      "name": "Source Serif Pro Bold",
      "url": "../assets/fonts/sourceserifpro/SourceSerifPro-Bold-msdf.json",
      "class": "font-source-serif-pro-bold"
    },
    {
      "name": "Ubuntu",
      "url": "../assets/fonts/ubuntu/Ubuntu-Regular-msdf.json",
      "class": "font-ubuntu"
    },
    {
      "name": "Ubuntu Bold",
      "url": "../assets/fonts/ubuntu/Ubuntu-Bold-msdf.json",
      "class": "font-ubuntu-bold"
    },
    {
      "name": "Varela",
      "url": "../assets/fonts/varela/Varela-Regular-msdf.json",
      "class": "font-varela"
    },
  ];

  public fontSizeOptions = [6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30];

  constructor() { }
}
